import { createContext } from 'react';
import { ConfirmOptions, ContextType } from 'ui-kit/confirm/confirm.type';

export default createContext<ContextType>((options: ConfirmOptions = {}) => Promise.resolve());
